
<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{'Accounting Transactions' | translate }}</h1>
          <p>{{'Enter Accounting Transactions' | translate }}</p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>

          </div>
  </div>
</section>
<div class="w3l-form-25">
  <BR>
      <label style="width: 250px;">   </label>
      <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
      <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
    </div>
<div id="w3l-appointment">
  <section class="appointment-section section-gap">

    <div class="wrapper">
            <div class="appointment-form">
                <form action="#" method="post">
                    <div class="fields-grid">

                        <a href="AccInvoice" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores" style="height: 100px;width:20%;" ><i class="fa fa-pencil-square-o" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Patients Invoice' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="revenued" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" style="height: 100px;width:20%;" (click)="Revenue()"><i class="fa fa-credit-card-alt" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Patients Payment' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="payments" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses" style="height: 100px;width:20%;"><i class="fa fa-cc" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Expenses' | translate }}</button>
                      </a>
                        <label style="width:2%;"></label>
                        <a href="StockTransactions" class="drop-text">
                                <button type="button" class="theme-button btn" (click)="Recv_Items()" name="bank" style="height: 100px;width:20%;"><i class="fa fa-book" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Receiving Items' | translate }}</button>
                        </a>
                      </div>
                    <div class="fields-grid">
                      <a href="StockTransactions" class="drop-text">
                       <button type="button" class="theme-button btn" (click)="Ret_Items()" name="stores" style="height: 100px;width:20%;" ><i class="fa fa-reply" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Returns to store' | translate }}</button>
                      </a>
                       <label  style="width:2%;"></label>
                       <a href="StockTransactions" class="drop-text">
                      <button type="button" class="theme-button btn" (click)="Issue_Items()" name="revenue" style="height: 100px;width:20%;"><i class="fa fa-list-ol" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Issue from store' | translate }}</button>
                       </a>
                      <label style="width:2%;"></label>
                      <a href="StockTransactions" class="drop-text">
                      <button type="button" class="theme-button btn" (click)="Refund_Items()" name="expenses" style="height: 100px;width:20%;"><i class="fa fa-share" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Refund from store' | translate }}</button>
                      </a>

                      <label style="width:2%;"></label>
                      <a href="StockTransactions" class="drop-text">
                       <button type="button" class="theme-button btn" (click)="Adjust_Items()" name="bank" style="height: 100px;width:20%;"><i class="fa fa-plus" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Adjustments' | translate }}</button>
                      </a>
                    </div>

                    <div class="fields-grid">
                      <a href="Home">
                        <button type="button" class="theme-button btn" style="width: 80%;height: 100px;" name="Back"><i class="fa fa-home" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Home' | translate }}</button>
                       </a>
                    </div>
                </form>
            </div>


        <div class="clear"> </div>
    </div>
</section>
</div>

